<template>
  <div class="salesTotalReport">
    <div class="content-container">
      <div class="titieMian">
        <div class="title-container">销售汇总表</div>
        <div class="select-container">
          <div class="select-container-box tab">
            <el-select
              v-model="memoryValue"
              size="small"
              placeholder="请选择"
              @click.native="visible = false"
              @change="changeBatDateList"
            >
              <el-option
                v-for="item in batDateList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box" v-if="memoryValue == 'date'">
            <el-date-picker
              size="small"
              v-model="startDate"
              type="date"
              :clearable="false"
              placeholder="开始日期"
              @change="changeTime(0)"
              value-format="yyyy-MM-dd"
              :picker-options="pickerTimeOptions"
            >
            </el-date-picker>
            <span class="space-text">至</span>
            <el-date-picker
              size="small"
              v-model="endDate"
              type="date"
              :clearable="false"
              placeholder="结束日期"
              @change="changeTime(1)"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptionsEnd"
            >
            </el-date-picker>
          </div>
          <div class="select-container-box" v-if="memoryValue == 'Batch'">
            <!-- <input-select :list="batchList" @changeValue="changeBatch" optionLabel="batchNo" optionValue="id"></input-select> -->
            <el-select
              v-model="batchNo"
              filterable
              placeholder="请选择"
              size="small"
              @click.native="visible = false"
              @change="changeBatch"
            >
              <el-option
                v-for="(item, index) in batchList"
                :key="index"
                :label="item.batchNo"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>仓库：</span>
            <el-select
              placeholder="请选择"
              size="small"
              @click.native="hide"
              v-model="warehouseId"
              @change="changeWare"
            >
              <el-input
                class="select-input"
                v-model="warehouseValue"
                placeholder="请输入内容"
                v-if="warehouseList.length > 7"
              ></el-input>
              <el-option
                v-for="(item, index) in warehouseListFilter(
                  warehouseValue,
                  warehouseList
                )"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <span>客户：</span>
            <!-- <el-select
              placeholder="请选择"
              size="small"
              @click.native="hide"
              v-model="clientId"
              @change="changeClient"
            >
              <el-option
                v-for="(item, index) in clientList"
                :key="index"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select> -->
            <el-input
              style="width: 145px"
              type="text"
              clearable
              v-model="Dealer"
              placeholder="请输入客户"
            ></el-input>
          </div>
          <el-popover
            class="pop-condition"
            placement="bottom"
            width="580"
            v-model="visible"
            trigger="click"
          >
            <div class="condition">
              <section class="mask">
                <div class="select-container-box">
                  <span>产品：</span>
                  <el-select
                    placeholder="请选择"
                    size="small"
                    v-model="productId"
                    @change="changeProduct"
                  >
                    <el-input
                      class="select-input"
                      v-model="productValue"
                      placeholder="请输入内容"
                      v-if="productList.length > 7"
                    ></el-input>
                    <el-option
                      v-for="(item, index) in productListFilter(
                        productValue,
                        productList
                      )"
                      :key="index"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="select-container-box">
                  <span>批次号：</span>
                  <el-input
                    clearable
                    type="text"
                    v-model="batchLike"
                    placeholder="请输入批次号"
                  ></el-input>
                  <!-- <el-select
                    placeholder="请选择"
                    size="small"
                    v-model="batchNo"
                    @change="changeBatch($event, 'pass')"
                  >
                    <el-input class="select-input" v-model="batchValue" placeholder="请输入内容" v-if="batchList.length > 7"></el-input>
                    <el-option
                      v-for="(item, index) in batchListFilter(batchValue, batchList)"
                      :key="index"
                      :label="item.batchNo"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select> -->
                </div>
                <div class="select-container-box">
                  <span>状态：</span>
                  <el-select
                    placeholder="请选择"
                    size="small"
                    v-model="statusId"
                    @change="changeStatus"
                  >
                    <el-input
                      class="select-input"
                      v-model="statusValue"
                      placeholder="请输入内容"
                      v-if="statusList.length > 7"
                    ></el-input>
                    <el-option
                      v-for="(item, index) in statusListFilter(
                        statusValue,
                        statusList
                      )"
                      :key="index"
                      :label="item.levelName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="select-container-box">
                  <span>计量单位：</span>
                  <div class="unit">
                    <el-radio v-model="radio" label="2">公斤</el-radio>
                    <el-radio v-model="radio" label="1">斤</el-radio>
                  </div>
                </div>
              </section>
              <div class="comfirm">
                <span @click="visible = false">取消</span>
                <span @click="search">查询</span>
              </div>
            </div>
            <div class="more" slot="reference">更多条件</div>
          </el-popover>

          <div class="select-container-box total">
            <span>汇总条件：</span>
            <el-select
              v-model="groupBy"
              multiple
              size="middle"
              @click.native="hide"
              placeholder="请选择"
              @change="chooseGroupBy"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="select-container-box">
            <el-button
              size="small"
              type="info"
              plain
              class="query"
              @click="search"
              >查询</el-button
            >
            <!-- <el-button size="small" style="background:#0fce82;border:none"  type="info" plain @click="exportData" class="add" >导出</el-button>
            <el-button size="small" style="background:#FF812D;border:none"  type="info" plain @click="printData" class="add" >打印</el-button> -->
          </div>
        </div>
      </div>
      <div class="table-container">
        <el-table
          :key="groupBy.join(',')"
          :summary-method="getSummaries"
          show-summary
          :data="totalDataList"
          style="width: 100%"
          size="medium"
          border
          v-loading="loading"
          :span-method="objectSpanMethod"
          :row-class-name="getRowClass"
        >
          <i slot="empty" style="font-style: normal" v-if="noData"
            >该时间段暂无数据</i
          >
          <i
            slot="empty"
            style="
              font-style: normal;
              position: relative;
              top: 18px;
              color: #666;
              z-index: 9999999;
            "
            v-if="loading"
            >数据拼命加载中.......</i
          >
          <el-table-column
            v-if="showCol(1)"
            prop="dealer"
            label="客户"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <a
                @click="handleDealer(scope.$index, scope.row)"
                class="content-edit"
                >{{ judgeTotal(scope.row) }}</a
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="warehouseName"
            label="仓库"
            v-if="showCol(2)"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.warehouseName == "" ||
                  scope.row.warehouseName == null
                    ? "--"
                    : scope.row.warehouseName
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="batch"
            label="批次"
            v-if="showCol(4)"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.batch == "" || scope.row.batch == null
                    ? "--"
                    : scope.row.batch
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="person"
            label="销售员"
            width="110"
            v-if="showCol(8)"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            v-if="showCol(16)"
            prop="productName"
            label="产品名称"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <a
                @click="handleProductName(scope.$index, scope.row)"
                class="content-edit"
                >{{ judgeType(scope.row) }}</a
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="species"
            label="规格"
            width="90"
            v-if="showCol(32)"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="level"
            label="状态"
            width="80"
            v-if="showCol(64)"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="quantity"
            label="数量"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="weight"
            label="重量"
            :formatter="formatterNumber"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="unit"
            label="计量单位"
            width="80"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="price"
            label="单价"
            width="110"
            :formatter="formatterNumber"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="amount"
            label="总金额"
            :formatter="formatterNumber"
            show-overflow-tooltip
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="smallChangeAmount"
            label="抹零金额"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.smallChangeAmount == null
                    ? "--"
                    : scope.row.smallChangeAmount
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="receivableAmount"
            label="应收金额"
            show-overflow-tooltip
            align="center"
          >
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.receivableAmount == null
                    ? "--"
                    : scope.row.receivableAmount
                }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { modules } from "../../store";
export default {
  name: "salesTotalReport",
  data() {
    return {
      noData: false,
      loading: true,
      warehouseValue: "",
      productValue: "",
      batchValue: "",
      statusValue: "",
      measureUnitDesc: "公斤",
      totalDataList: [],
      visible: false,
      warehouseList: [],
      warehouseId: "",
      productList: [],
      productId: "",
      clientList: [],
      clientId: "",
      batchList: [], //批次
      batchNo: "",
      statusList: [], // 状态
      statusId: "",
      startDate: "",
      endDate: "",
      batchLike: "",
      radio: window.localStorage.getItem("measureUnitDesc") == "斤" ? "1" : "2",
      memoryValue: "Batch",
      pass: "", //是否传批次号
      pickerOptionsStart: {
        disabledDate: (time) => {
          let endDateVal = this.endDate;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          let beginDateVal = this.startDate;
          if (beginDateVal) {
            return time.getTime() < new Date(beginDateVal).getTime();
          }
        },
      },
      // 限制日期
      pickerTimeOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      batDateList: [
        {
          value: "Batch",
          label: "批次号",
        },
        {
          value: "date",
          label: "时间",
        },
      ],
      options: [
        {
          value: "1",
          label: "客户",
        },
        {
          value: "2",
          label: "仓库",
        },
        {
          value: "4",
          label: "批次",
        },
        {
          value: "8",
          label: "销售员",
        },
        {
          value: "16",
          label: "产品",
        },
        {
          value: "32",
          label: "规格",
        },
        {
          value: "64",
          label: "状态",
        },
      ],
      groupIndex: 0,
      order: {
        date: "",
        groupBy: 7, //汇总方式-默认第一个和第二个
        baseId: "", //基地
        Way: "",
      },
      groupBy: ["1", "2", "4"], //汇总方式
      wayList: [],
      spanArr: [],
      spanArr1: [],
      spanArr2: [],
      position: 0, // spanArr 的索引
      position1: 0,
      position2: 0,
      list: [],
      tableData4: [],
      Dealer: "",
    };
  },
  watch: {
    groupBy: function (val, oldVal) {
      if (val.length < 1) {
        this.$Alert.info({
          content: "必须选中一项",
          duration: 3000,
          status: "error",
        });
        this.groupBy = oldVal;
      }
    },
  },
  //默认时间
  created() {
    let startTime = localStorage.getItem("start");
    let endTime = localStorage.getItem("end");
    if (startTime) {
      this.startDate = this.$timeformatDay(startTime);
    } else {
      const start = new Date();
      start.setMonth(start.getMonth() - 1);
      start.setDate(1);
      this.startDate = this.$timeformatDay(start);
    }
    if (endTime) {
      this.endDate = endTime;
    } else {
      this.endDate = this.$timeformatDay(new Date());
    }
  },
  async mounted() {
    setTimeout(() => {
      let measureUnitDesc = window.localStorage.getItem("measureUnitDesc");
      this.measureUnitDesc = measureUnitDesc;
      if (measureUnitDesc == "公斤") {
        this.radio = "2";
      } else {
        this.radio = "1";
      }
    }, 1000);

    this.judgeChoose();
    this.groupIndex = 0;
    this.groupBy.forEach((item) => {
      this.groupIndex = parseInt(this.groupIndex) + parseInt(item);
    });
    this.search();
    let result = await this.ajaxGetCompanySettingData(); //获取当前公司
    await this.ajaxStatusList(this.order.enterpriseId); //获取状态列表
    await this.ajaxBatchList(); // 获取批次列表
    let warehouse = await this.getWarehouseList({
      pageIndex: 1,
      pageSize: 1000000,
      keyword: "",
    });
    this.warehouseList = warehouse.list;
    this.warehouseList = [
      {
        id: "",
        name: "全部",
      },
    ].concat(this.warehouseList);
    let product = await this.getProductList({
      pageIndex: 1,
      pageSize: 1000000,
      queryName: "",
    });
    this.productList = product.list;
    this.productList = [
      {
        id: "",
        name: "全部",
      },
    ].concat(this.productList);
    let client = await this.getAllClient({
      pageIndex: 1,
      pageSize: 1000000,
      type: 1,
      name: "",
      contactPerson: "",
      phone: "",
    });
    this.clientList = client.list;
    this.clientList = [
      {
        id: "",
        name: "全部",
      },
    ].concat(this.clientList);
  },
  methods: {
    ...mapActions(modules.warehouse, ["getWarehouseList"]),
    ...mapActions(modules.product, ["getProductList"]),
    ...mapActions(modules.supplier, ["getAllClient"]),
    ...mapActions(modules.batch, {
      getBatchList: "getBatchList",
    }),
    ...mapActions(modules.user, {
      getCompanySettingData: "getCompanySettingData",
    }),
    ...mapActions(modules.purchase, {
      getStatusList: "getStatusList",
      getSalesTotalReport: "getSalesTotalReport",
    }),
    warehouseListFilter(key, list) {
      // 我这里直接return（也可赋给变量return变量出去）
      if (key == "") {
        return list;
      } else {
        return list.filter((item) => {
          // 如果list(name)包含key(输入框) => true
          if (item.name.includes(key)) {
            // 返回item
            return item;
          }
        });
      }
    },
    productListFilter(key, list) {
      // 我这里直接return（也可赋给变量return变量出去）
      if (key == "") {
        return list;
      } else {
        return list.filter((item) => {
          // 如果list(name)包含key(输入框) => true
          if (item.name.includes(key)) {
            // 返回item
            return item;
          }
        });
      }
    },
    batchListFilter(key, list) {
      // 我这里直接return（也可赋给变量return变量出去）
      if (key == "") {
        return list;
      } else {
        return list.filter((item) => {
          // 如果list(name)包含key(输入框) => true
          if (item.batchNo.includes(key)) {
            // 返回item
            return item;
          }
        });
      }
    },
    statusListFilter(key, list) {
      // 我这里直接return（也可赋给变量return变量出去）
      if (key == "") {
        return list;
      } else {
        return list.filter((item) => {
          // 如果list(name)包含key(输入框) => true
          if (item.levelName.includes(key)) {
            // 返回item
            return item;
          }
        });
      }
    },
    //存储选中时间
    changeTime(type) {
      if (type == 0) {
        localStorage.setItem("start", this.startDate);
      } else {
        localStorage.setItem("end", this.endDate);
      }
    },
    // 列的显示隐藏
    showCol(index) {
      return this.groupBy.some((item) => {
        return item == index;
      });
    },
    hide() {
      this.visible = false;
    },
    // 记录选中批次还是时间
    judgeChoose() {
      let memoryValue = localStorage.getItem("memoryValue");
      if (memoryValue == null || memoryValue == undefined) {
        this.memoryValue = "Batch";
      } else if (memoryValue !== "receiptDate") {
        this.memoryValue = memoryValue;
        if (this.memoryValue == "date") {
          this.batch = "";
        }
      }
    },
    // 切换批次日期
    changeBatDateList(e) {
      localStorage.setItem("memoryValue", e);
      console.log(e);
      if (e == "Batch") {
        // this.start = "";
        // this.end = "";
      } else if (e == "date") {
        this.batchNo = "";
      }
    },
    // 选择汇总条件
    chooseGroupBy(arr) {
      this.groupIndex = 0;
      this.groupBy = this.groupBy.sort((a, b) => {
        return a - b;
      });
      arr.forEach((item) => {
        this.groupIndex = parseInt(this.groupIndex) + parseInt(item);
      });
      this.$nextTick(() => {
        if (arr.length !== 0) {
          this.search();
        }
      });
    },
    // 获取批次
    ajaxBatchList() {
      let obj = {
        pageIndex: 1,
        pageSize: 10000,
        keyword: "",
      };
      this.getBatchList(obj).then((data) => {
        data.list.forEach(function (item) {
          item.id = item.batchNo;
        });
        this.batchList = data.list;
        this.batchList = [
          {
            id: "",
            batchNo: "全部",
          },
        ].concat(this.batchList);
      });
    },
    // 获取当前公司
    async ajaxGetCompanySettingData() {
      await this.getCompanySettingData().then((data) => {
        this.order.enterpriseId = data.enterpriseID;
        this.order.enterpriseName = data.enterpriseName;
      });
    },
    // 获取状态列表
    async ajaxStatusList(enterpriseId) {
      await this.getStatusList(enterpriseId).then((data) => {
        this.statusList = data.data;
        let list = this.statusList.map((item, index) => {
          var temp = {};
          temp.id = item.levelName;
          temp.levelName = item.levelName;
          return temp;
        });
        this.statusList = list;
        this.statusList = [
          {
            id: "",
            levelName: "全部",
          },
        ].concat(this.statusList);
      });
    },
    formatterNumber(row, column, cellValue) {
      if ((!cellValue && cellValue != 0) || cellValue == "--") {
        return "--";
      }
      return cellValue.toFixed(2);
    },

    // 切换仓库
    changeWare(e) {
      this.warehouseId = e;
      this.warehouseValue = "";
      this.search();
    },
    // 切换客户
    changeClient(e) {
      this.clientId = e;
      this.search();
    },
    // 切换产品
    changeProduct(e) {
      this.productValue = "";
      this.productId = e;
      this.search();
    },
    // 切换批次
    changeBatch(e, str = "") {
      if (str == "pass") {
        this.pass = true;
      }
      this.batchValue = "";
      this.batchNo = e;
      this.search();
    },
    // 切换状态
    changeStatus(e) {
      this.statusId = e;
      this.search();
    },
    judgeType(item, name) {
      if (item.itemType == 1) {
        return item.productName;
      } else if (item.itemType == 2) {
        return "小计";
      }
    },
    judgeTotal(item) {
      if (item.itemType == 3) {
        return "总计";
      } else {
        return item.dealer;
      }
    },
    getRowClass(e) {
      if (e.row.itemType == 2) {
        return "subtotal";
      } else if (e.row.itemType == 3) {
        return "alltotal";
      } else {
        return "normal";
      }
    },
    formateproduct(row) {
      console.log(row);
      return "444";
    },
    //合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        if (
          column.property === "batch" ||
          column.property === "level" ||
          column.property === "person" ||
          column.property === "warehouseName" ||
          column.property === "unit" ||
          column.property === "productName" ||
          column.property === "price" ||
          column.property === "species"
        ) {
          sums[index] = "--";
          return;
        }
        const values = data.map((item) => {
          if (item.itemType == 1) {
            return Number(item[column.property]);
          }
        });
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2) + " ";
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
    // 点击客户
    handleDealer(index, row) {
      console.log(index, row);
      this.$router.push({
        name: "salesDetail",
        query: {
          dealerId: row.dealerId,
          dealer: row.dealer,
        },
      });
    },
    // 点击产品
    handleProductName(index, row) {
      this.$router.push({
        name: "salesDetail",
        query: {
          productId: row.productId,
          productName: row.productName,
          dealerId: row.dealerId,
          dealer: row.dealer,
        },
      });
    },
    // 导出
    exportData() {
      console.log("daochu");
    },
    // 打印
    printData() {
      console.log("dayin");
    },
    //查询
    async search() {
      if (this.groupBy.length == 0) {
        this.$Alert.info({
          content: "请选择汇总条件",
          duration: 3000,
          status: "error",
        });
        return;
      }
      this.visible = false;
      let endDate = this.endDate;
      if(endDate){
        const date = new Date(endDate);  
        date.setDate(date.getDate() + 1);  
        endDate = date.toISOString().slice(0, 10); 
      }
      this.getSalesTotalReport({
        StartTime: this.memoryValue == "date" ? this.startDate : "",
        EndTime: this.memoryValue == "date" ? endDate : "",
        WarehouseId: this.warehouseId,
        Dealer: this.Dealer,
        Batch: this.pass || this.memoryValue == "Batch" ? this.batchNo : "",
        ProductId: this.productId,
        Unit: this.radio,
        Level: this.statusId,
        GroupBy: this.groupIndex,
        batchLike: this.batchLike,
      })
        .then((data) => {
          this.loading = false;
          this.totalDataList = data;
          if (this.totalDataList.length != 0) {
            this.noData = false;
            this.rowSpan(this.totalDataList);
          } else {
            this.noData = true;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    rowSpan(data) {
      this.spanArr = [];
      this.spanArr1 = [];
      this.spanArr2 = [];
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.position = 0;
          this.spanArr1.push(1);
          this.position1 = 0;
        } else {
          // 判断当前元素与上一个元素是否相同,因合并第一个所以[0]
          if (
            data[i]["dealerId"] === data[i - 1]["dealerId"] &&
            this.groupBy.indexOf("1") > -1
          ) {
            this.spanArr[this.position] += 1;

            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);

            this.position = i;
          }
          if (
            (this.groupBy.indexOf("1") < 0 ||
              data[i]["dealerId"] === data[i - 1]["dealerId"]) &&
            data[i]["warehouseId"] === data[i - 1]["warehouseId"] &&
            this.groupBy.indexOf("2") > -1
          ) {
            this.spanArr1[this.position1] += 1;
            this.spanArr1.push(0);
          } else {
            this.spanArr1.push(1);
            this.position1 = i;
          }
        }
      }
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === this.groupBy.indexOf("1")) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === this.groupBy.indexOf("2")) {
        const _row = this.spanArr1[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
};
</script>

<style lang="stylus">
.pop-condition{
  .more{
    margin-left:20px;
    padding:0 20px;
    line-height:32px;
    background:linear-gradient(180deg,rgba(255,255,255,1),rgba(230,230,230,1));
    border:1px solid rgba(198, 198, 198, 1);
    border-radius:4px;
    color:#333333;
    cursor:pointer;
  }
}
.salesTotalReport{
  .tab{
    .el-input--small{
      width:100px !important;
      min-width:100px !important;
    }
  }

  .total{
    .el-select__tags{
      top:65%;
      height: 30px;
      overflow: auto;
    }
    .el-input__suffix{
      top:6px;
    }
    .is-focus .el-input__suffix {
      top:0px;
    }

  }
  .normal{
    a{
      text-decoration :underline;
    }

  }
  .subtotal{
    td{
      background:#fff!important;
      .cell{
        font-family:Microsoft YaHei;
        font-weight:bold;
        color:#454e58 !important;
        background:#fff;
      }

      .content-edit{
        background:#fff;
        font-weight:bold;
        color:#454e58 !important;
      }
    }
  }
  .alltotal{
    td{
     background:#FFF;

      .content-edit{
        font-weight:bold;
        color:#333333 !important;
      }
      .cell{
        font-weight:bold;
        color:#333333 !important;
      }
    }
  }
}

.el-popover{
  width:580px !important;

  .unit{
    display:inline-block;
    line-height 32px;
    width:180px;
    text-align:left;
  }
  .condition{
    color:#333;
    font-size:16px;
    .more{
      height:32px;
      padding:0 12px;
      border-radius:5px;
      line-height:32px;
      font-size:14px;
      color:#333;
      cursor:pointer;
      background:linear-gradient(180deg,rgba(255,255,255,1),rgba(230,230,230,1));
      border:1px solid rgba(198, 198, 198, 1);
    }
  }
  .mask{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding:5px 20px 15px 20px;
    z-index: 20;
    font-size:16px;
    color:#666;
    background:#fff;
    .more{
      margin-left:20px;
    }
    .select-container-box{
      width :260px;
      margin-top:15px;
    }
    .el-input{
      width :180px;
    }
    .el-input__inner{
      height 36px;
      width :180px;
    }
    >div{
      &:nth-child(2n) {
        // text-align :right;
        padding-left:0;
        >span{width:80px;text-align:right;}
      }
    }
  }

  .comfirm{
    text-align:center;
    font-size:16px;

     >span{
      display:inline-block;
      width:100px;
      margin:15px 0;
      border:1px solid #BBBBBB;
      border-radius:4px;
      line-height:36px;
      background :#fff;
      cursor:pointer;
      &:nth-child(2){
        margin-left:20px;
        border:1px solid #3389FF;
        color:#fff;
        background:#3389FF;
      }
    }
  }
}
</style>
<style lang="stylus">
// .salesTotalReport

//   .content-container .select-container-box:last-child {
//     margin-left: 0px;
//   }
//   .content-container .select-container-box .el-select__tags {
//     max-width: 230px !important;
//     width:230px!important;
//   }
//   .el-table__body-wrapper{
//     max-height:calc(100vh - 282px)
//     overflow-y:auto;
//   }
//   .el-table::before{
//     width 100%!important
//     border-bottom:1px solid #DDDDDD!important
//   }
//   .el-table .el-table__body tbody td{
//     border-bottom 1px solid #DDD!important;
//   }
//   .el-table .el-table__row:nth-of-type(even){
//     background #fff !important;
//   }
//   .table-container
//     .el-table::before
//       width:100%!important
//       border-bottom:1px solid #DDDDDD!important
//     .el-table .el-table__body tbody td
//       border-bottom 1px solid none !important;
//     .el-table .el-table__row:nth-of-type(even)
//   .el-table__footer-wrapper
//     tr td {
//       background:#FFF8F2;
//       .cell{
//         padding:12px 0;
//         line-height:normal !important;
//       }
//     }

.salesTotalReport

  .content-container .select-container-box:last-child {
    margin-left: 0px;
  }
  .content-container .select-container-box .el-select__tags {
    max-width: 230px !important;
    width:230px!important;
  }
  .el-table__body-wrapper{
    max-height:calc(100vh - 282px)
    overflow-y:auto;
  }
  .el-table::before
    width:100%!important
    border-bottom:0.5px solid #DDDDDD!important
  .el-table .el-table__body tbody td
    border-bottom 1px solid #DDD!important;
  .el-table .el-table__row:nth-of-type(even)
    background #fff !important;
  .el-table__footer-wrapper
    tr td {
      background:#FFF8F2;
      .cell{
        padding:12px 0;
        line-height:normal !important;
      }
    }
</style>
